import { createBrowserRouter } from "react-router-dom";
import App from "./App";
import OnboardingWizard from "./features/onboarding/pages/OnboardingWizard";
import ThankYouPage from "./features/onboarding/pages/ThankYouPage";
import MaintenancePage from "./features/onboarding/pages/MaintenancePage";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      { index: true, element: <OnboardingWizard /> },
      { path: "thank-you", element: <ThankYouPage /> },
      { path: "maintenance", element: <MaintenancePage /> },
    ],
  },
]);
